/* eslint-disable @typescript-eslint/no-unused-vars */
import { Helmet } from 'react-helmet-async';

import { _mock, _server_list } from 'src/_mock';

import { _security } from 'src/_mock/_security';
import { _app_quality } from 'src/_mock/_app_quality';
import RatingComponent from 'src/components/rating/rating';
import QAWrapperComponent from './QAWrapperComponent/QAWrapperComponent';

const AppDetails = () => {
  const _column_data: any = {
    type: {
      // 'Application Name': 'text',
      'DB Size(TB)': 'number',
      'Total Size(TB)': 'number',
      'Audit Log(TB)': 'rating',
      Comments: 'text',
      Frequency: 'number',
      Expansion: 'number',
      Training: 'number',
      BI: 'boolean',
      Revenue: 'boolean',
      Growth: 'boolean',
      Uniqueness: 'number',
      Stability: 'number',
      Maintenance: 'number',
      'Outage Impact': 'number',
      Value: 'number',
      'Sole Source': 'boolean',
      Redundancy: 'number',
    },
    options: {},
    column_questions: {
      // 'Application Name': 'text',
      'DB Size(TB)': 'What is the size of the database in TB?',
      'Total Size(TB)':
        'What is the total data footprint (in TB) of the application including documents, images, etc?',
      'Audit Log(TB)': 'How much data is stored in user/audit logs?',
      Comments: 'What other technical details would be helpful to know about this application?',
      Frequency: 'How often is the application used?',
      Expansion:
        'How well does this application scale to handle greater transaction volumes and support additional users (internal or external to your organization)?',
      Training: 'How difficult is it to onboard and train a new user?',
      BI: 'Does this application integrate with a BI tool?',
      Revenue: 'Does this application generate revenue?',
      Growth: 'Revenue growth potential?',
      Uniqueness:
        "Is this application's functionality similar to another already used by your organization?",
      Stability: 'How stable is the system?',
      Maintenance: 'number',
      'Outage Impact':
        'How does a 24 hour, unplanned outage of this application impact your organization?',
      Value: "What is the application's business value?",
      'Sole Source':
        'Is the application is an authoritative source or Exclusive Record of Origin (ROO) for the stored data?',
      Redundancy: 'What level of redundancy is used for application continuity?',
    },
    renderCell: {
      Stability: RatingComponent,
      Maintenance: RatingComponent,
      'Outage Impact': RatingComponent,
      Value: RatingComponent,
      Redundancy: RatingComponent,
      'Audit Log(TB)': RatingComponent,
      Expansion: RatingComponent,
      Uniqueness: RatingComponent,
      Training: RatingComponent,
      Frequency: RatingComponent,
    },
    renderEditCell: {
      Stability: RatingComponent,
      Maintenance: RatingComponent,
      'Outage Impact': RatingComponent,
      Value: RatingComponent,
      Redundancy: RatingComponent,
      'Audit Log(TB)': RatingComponent,
      Expansion: RatingComponent,
      Uniqueness: RatingComponent,
      Training: RatingComponent,
      Frequency: RatingComponent,
    },
    disableEdit: {
      Name: true
    }
  };

  const gridData: any = {
    appDetails_home: {
      _dataGrid_0: [...Array(15)].map((_, index) => {
        const status =
          (index % 2 && 'online') || (index % 3 && 'alway') || (index % 4 && 'busy') || 'offline';

        return {
          id: _mock.id(index),
          // 'Application Name': _app_quality.application_name(index),
          'Name ': _mock.app_details.name(index),
          Department: _mock.app_details.department(index),
          Vendor: _mock.app_details.vendor(index),
        };
      }),
    },
    appDetails_details: {
      _dataGrid_0: [...Array(15)].map((_, index) => {
        const status =
          (index % 2 && 'online') || (index % 3 && 'alway') || (index % 4 && 'busy') || 'offline';

        return {
          id: _mock.id(index),
          // 'Application Name': _app_quality.application_name(index),
          Name: _mock.app_details.name(index),
          'DB Size(TB)': _app_quality.db_size(index),
          'Total Size(TB)': _app_quality.total_size(index),
          'Audit Log(TB)': _app_quality.audit_log(index),
          Comments: _app_quality.comments(index),
        };
      }),
    },
    appDetails_usefulness: {
      _dataGrid_0: [...Array(15)].map((_, index) => {
        const status =
          (index % 2 && 'online') || (index % 3 && 'alway') || (index % 4 && 'busy') || 'offline';

        return {
          id: _mock.id(index),
          // status,
          Name: _mock.app_details.name(index),
          Frequency: _app_quality.frequency(index),
          Expansion: _app_quality.expansion(index),
          Training: _app_quality.training(index),
          BI: _app_quality.bi(index),
          Revenue: _app_quality.revenue(index),
          Growth: _app_quality.growth(index),
          Uniqueness: _app_quality.uniqueness(index),
        };
      }),
    },
    appDetails_business_risks: {
      _dataGrid_0: [...Array(15)].map((_, index) => {
        const status =
          (index % 2 && 'online') || (index % 3 && 'alway') || (index % 4 && 'busy') || 'offline';

        return {
          id: _mock.id(index),
          // status,
          Name: _mock.app_details.name(index),
          Stability: _app_quality.stability(index),
          Maintenance: _app_quality.maintenance(index),
          'Outage Impact': _app_quality.outage_impact(index),
          Value: _app_quality.value(index),
          'Sole Source': _app_quality.sole_source(index),
          Redundancy: _app_quality.redundancy(index),
        };
      }),
    },
  };
  const TABS = [
    { value: 'appDetails_home', label: 'Home', color: 'default' },
    { value: 'appDetails_details', label: 'Details', color: 'default' },
    {
      value: 'appDetails_usefulness',
      label: 'Usefulness',
      color: 'success',
    },
    {
      value: 'appDetails_business_risks',
      label: 'Business Risks',
      color: 'warning',
    },
  ] as const;

  return (
    <>
      <Helmet>
        <title> Dashboard: Security/Infra</title>
      </Helmet>

      <QAWrapperComponent
        TABS={TABS}
        gridData={gridData}
        _column_data={_column_data}
        title="App Details"
      />
    </>
  );
};

export default AppDetails;
